import { put, takeLatest, call } from 'redux-saga/effects';
import { OK } from 'http-status-codes';

import { safeResolveAsync } from '../../utils/saga';

import * as api from './api';
import { types, actions } from './duck';

// ---------------------------------
// GET PRODUCTS
// ---------------------------------
function* getProductsSaga() {
  try {
    yield put(actions.getProductsRequest());

    const response = yield call(api.getBusinessProductsApi);

    if (response.status === OK) {
      yield put(actions.getProductsSuccess(response.data));
    } else {
      yield put(
        actions.getProductsFailure(
          'Failed to load products'
        )
      );
    }
  } catch (err) {
    yield put(
      actions.getProductsFailure(
        err.message || 'Failed to load products'
      )
    );
  }
}

// ---------------------------------
// PAY BY POINTS
// ---------------------------------
function* payByPointsSaga({ payload, resolve }) {
  try {
    yield put(actions.payByPointsRequest());

    const response = yield call(
      api.productsPayByPointsApi,
      payload
    );

    if (response.status === OK && response.data.success) {
      yield put(
        actions.payByPointsSuccess(response.data)
      );

      yield safeResolveAsync(
        resolve,
        response.data
      );
    } else {
      const errorMessage =
        response.data.error ||
        response.statusText ||
        'Payment failed';

      yield put(
        actions.payByPointsFailure(errorMessage)
      );

      yield safeResolveAsync(resolve, {
        success: false,
        error: errorMessage,
      });
    }
  } catch (err) {
    const errorMessage =
      err.response.data.error ||
      'Internal server error. Please try again.';

    yield put(
      actions.payByPointsFailure(errorMessage)
    );

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}

// ---------------------------------
// ROOT SAGA
// ---------------------------------
export default function* productsSaga() {
  yield takeLatest(
    types.GET_PRODUCTS,
    getProductsSaga
  );

  yield takeLatest(
    types.PAY_BY_POINTS,
    payByPointsSaga
  );
}